module.exports = __webpack_public_path__ + "static/assets/about4.51923fad.jpg";